export const baseUrl = process.env.REACT_APP_BASE_URL;
export const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;
export const COORDINATES_ATHENS_CENTER = { lat: 37.98381, lng: 23.727539 };
